import "./App.css";

import { Link } from "react-router-dom";
import TrainingProviderOnboardingBody from "./TrainingProviderOnboardingBody";

const partnershipEmail =
  "mailto:contact@fit-match.co.uk?subject=Edinburgh%20PT%20Academy%20%E2%80%94%20partnership%20%26%20feedback";

const shareUrl = "fit-match.co.uk/onboarding-edinburgh-pt-academy";

/**
 * Personal follow-up for Edinburgh PT Academy (James) — extends the generic
 * training provider onboarding with a thank-you and shared overview.
 */
function OnboardingEdinburghPtAcademy() {
  return (
    <div className="bg-black text-gray-200 min-h-screen">
      <header className="bg-black bg-opacity-90 backdrop-blur-lg sticky top-0 w-full z-50 border-b border-gray-800">
        <nav className="container mx-auto px-6 py-4 flex flex-wrap items-center justify-between gap-4">
          <Link to="/" className="flex items-center space-x-2">
            <img
              src="/images/logo.png"
              alt="Fit-Match Logo"
              className="h-12 w-auto md:h-14"
            />
            <span className="text-xl md:text-2xl font-bold gradient-text">
              FIT-MATCH
            </span>
          </Link>
          <div className="flex items-center gap-4 text-sm md:text-base">
            <Link to="/" className="text-gray-300 hover:text-white nav-link">
              Home
            </Link>
            <a
              href={partnershipEmail}
              className="text-green-400 hover:text-green-300 font-medium"
            >
              Contact us
            </a>
          </div>
        </nav>
      </header>

      <main>
        <section className="relative overflow-hidden border-b border-gray-800 bg-gradient-to-b from-gray-900 via-black to-black py-14 md:py-20">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-900/20 via-transparent to-transparent pointer-events-none" />
          <div className="container relative z-10 mx-auto max-w-3xl px-6 text-center">
            <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-blue-fit-match">
              Edinburgh PT Academy
            </p>
            <h1 className="mb-8 text-3xl font-bold leading-tight text-white md:text-4xl">
              Thanks, James
            </h1>
            <div className="space-y-5 text-left text-lg leading-relaxed text-gray-300 md:text-center">
              <p>
                Thank you for taking the time to speak with us — we really
                appreciated the conversation and learning more about how you
                work with your graduates.
              </p>
              <p>
                We are excited about the idea of onboarding{" "}
                <strong className="text-white">Edinburgh PT Academy</strong> and
                your grads on Fit-Match, and we are{" "}
                <strong className="text-white">keen to hear your feedback</strong>{" "}
                as we move forward — whether that is on the partnership, the
                product, or what would make this genuinely useful for your
                cohorts.
              </p>
              <p className="text-base text-gray-500 md:text-center">
                Below is the training-provider overview you can revisit or
                share with your team — everything in one place.
              </p>
            </div>
          </div>
        </section>

        <TrainingProviderOnboardingBody
          shareUrl={shareUrl}
          partnershipEmail={partnershipEmail}
        />
      </main>

      <footer className="border-t border-gray-800 bg-gray-900 py-8 text-center text-sm text-gray-500">
        <Link to="/" className="hover:text-gray-300">
          ← Back to Fit-Match home
        </Link>
        <p className="mt-4">
          &copy; {new Date().getFullYear()} Fit-Match. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default OnboardingEdinburghPtAcademy;
